function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, String, errored, searchedText, shortenedTable) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['field-with-matches'] = function(item, context) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((context.matchParts) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = (context.matchParts);
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, part, $index) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", {
                      "class": {
                        'mp-table-cell-match-part': true
                      },
                    }, [__vjadeSafeCode(part)]));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var $index = $$objKey;
                    if ($$obj.hasOwnProperty($index)) {
                      $$iterated = true;
                      var part = $$obj[$index];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("span", {
                          "class": {
                            'mp-table-cell-match-part': true
                          },
                        }, [__vjadeSafeCode(part)]));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-table-cell-label': true
              },
            }, [__vjadeSafeCode(context.label)]));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['new-modal-cell-entity-name-renderer'] = function(entity, context) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": Object.assign({}, {
            'shortened': shortenedTable
          }, {
            'cell-entity-name': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($helpers.getEntityIcon(entity)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'cell-entity-icon': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: $helpers.getEntityIcon(entity)
                }),
              }));
              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  placement: `right`
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat($helpers.getEntityDisplayType(entity));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'cell-entity-title': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("a", {
              "attrs": __vjadeStringifyAttrsIfObj({
                href: entity.link
              }),
              "class": {
                'entity-link': true
              },
            }, [__vjadeSafeCode(entity.name)]));
            __jade_nodes = __jade_nodes.concat((entity.description) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'cell-entity-description': true
                },
              }, [__vjadeSafeCode(entity.description)]));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'load-entity-modal': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`open`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-modal", {
            "attrs": __vjadeStringifyAttrsIfObj($helpers.getLoadModalAttributes()),
            "on": {
              change: $helpers.handleLoadModalStateChange
            },
            "class": {
              'modal': true,
              'load-entity-modal': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("section", {
              "class": {
                'new-load-modal-wrapper': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("section", {
                "class": {
                  'new-load-modal-header': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("h2", {
                  "class": {
                    'modal-title': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Browse");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("load-entity-options-bar", {
                  "hook": {
                    insert: $helpers.optionsBarInserted
                  },
                  "attrs": __vjadeStringifyAttrsIfObj({
                    elref: `entityOptionsBar`,
                    'options': $helpers.getFilterOptions(),
                    'search-placeholder': `Search Reports and Dashboards...`,
                    'search-text': searchedText,
                  }),
                  "on": {
                    'clickItem': $helpers.handleOptionSelected,
                    resetSections: $helpers.handleResetSections,
                    slideChange: $helpers.handleSlideChange,
                    'submitSearch': $helpers.handleSubmitSearch,
                    'updateInput': $helpers.handleNewSearchText,
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat((errored) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'new-modal-error-state': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h('div', {
                    props: {
                      innerHTML: '<svg width="165" height="117" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M143 109h-17.2c-1.1 0-2-.9-2-2s.9-2 2-2H143c5.5 0 10-4.5 10-10V14c0-5.5-4.5-10-10-10H36.6c-1.1 0-2-.9-2-2s.9-2 2-2H143c7.7 0 14 6.3 14 14v81c0 7.7-6.3 14-14 14z" fill="#E4567B"/><path d="M124.1 109H22c-7.7 0-14-6.3-14-14V14C8 6.3 14.3 0 22 0h45.3c1.1 0 2 .9 2 2s-.9 2-2 2H22c-5.5 0-10 4.5-10 10v81c0 5.5 4.5 10 10 10h102.1c1.1 0 2 .9 2 2s-.9 2-2 2zM2 113h161c1.1 0 2 .9 2 2s-.9 2-2 2H2c-1.1 0-2-.9-2-2s.9-2 2-2z" fill="#E4567B"/><path d="M23 11h119c2.2 0 4 1.8 4 4v79c0 2.2-1.8 4-4 4H23c-2.2 0-4-1.8-4-4V15c0-2.2 1.8-4 4-4z" fill="#FDF3F6"/><path d="M98.2 64L86 42.5c-1.9-3.3-5-3.3-6.9 0L66.8 63.6c-1.9 3.3-.4 6.4 3.4 6.4h24.5c3.8 0 5.4-2.7 3.5-6zm-15.6 2c-1.2 0-2.1-.9-2.1-2.1 0-1.2.9-2.1 2.1-2.1 1.2 0 2.1.9 2.1 2.1.1 1.1-.9 2.1-2.1 2.1zm1.5-5.6h-3l-1-12.3h5l-1 12.3z" fill="#E4567B"/></g></svg>'
                    }
                  }));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'new-modal-error-title': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Something happened...");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'new-modal-error-subtitle': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("We're thinking this isn't the result you want");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'new-modal-error-details': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("If this error persists, please contact");
                    __jade_nodes = __jade_nodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("" + (` `) + "");
                      __jade_nodes = __jade_nodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("a", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            href: 'https://mixpanel.com/get-support',
                            target: '_blank'
                          }),
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("support");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                      __jade_nodes = __jade_nodes.concat(", or check our");;
                      return __jade_nodes
                    }).call(this));
                    __jade_nodes = __jade_nodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("" + (` `) + "");
                      __jade_nodes = __jade_nodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("a", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            href: 'https://status.mixpanel.com/',
                            target: '_blank'
                          }),
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat("status page");;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                      __jade_nodes = __jade_nodes.concat("");;
                      return __jade_nodes
                    }).call(this));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-table", {
                  "attrs": __vjadeStringifyAttrsIfObj($helpers.getNewTableAttrs()),
                  "props": {
                    rows: $helpers.getRealSearchRows(),
                    columns: $helpers.getNewTableColumns($mixins),
                  },
                  "on": {
                    rowClick: $helpers.onRowSelect,
                    track: $helpers.trackTableEvents,
                  },
                  "style": {
                    'width': shortenedTable ? `75%` : `100%`
                  },
                }));;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "errored" in locals ? locals.errored : typeof errored !== "undefined" ? errored : undefined, "searchedText" in locals ? locals.searchedText : typeof searchedText !== "undefined" ? searchedText : undefined, "shortenedTable" in locals ? locals.shortenedTable : typeof shortenedTable !== "undefined" ? shortenedTable : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;